import React from 'react';
import { Page, Text, View, Document, Font } from '@react-pdf/renderer';
import Image from '../../common/PDF/Image';
import styles from '../../common/PDF/LayoutStylesheet';
import Table from '../../common/PDF/Table';
import TransactionTypesPDF from '../../common/Stats/TransactionTypes/PDF';
import OverviewPDF from '../../common/PDF/Overview';
import DateRange from '../../common/PDF/DateRange';
import MainFilterSummary from '../../common/PDF/MainFilterSummary';
import EntityTablePDF from '../home/EntityTable/PDF';
import TerritoryTablePDF from '../home/Territory/PDF';
import RollingMonthRevenuePDF from './RollingMonthRevenue/PDF';
import VendorTablePDF from '../home/Vendor/PDF';
import MetricsPDF from './MetricsPDF';
import CountriesPDF from './Countries/PDF';

export default (props) => {
	const { data: { images, tables, reportTitle } } = props;
	const allViews = {
			"metrics": <View style={styles.columnSection}>
			<View style={styles.column}>
				<Text style={styles.smallHeader}>Revenue by Source</Text>
				<MetricsPDF data={tables.overview} />
			</View>
			</View>,
			"countries": <View style={styles.columnSection}>
			<View style={styles.column}>
				<Text style={styles.smallHeader}>Countries</Text>
				<CountriesPDF data={tables.countries} />
			</View>
			</View>,

		  "rolling_months_revenue": <View style={styles.columnSection}>
			  <View style={styles.column}>
				  <Text style={styles.smallHeader}>Rolling 12 Months Revenue</Text>
				  <RollingMonthRevenuePDF data={tables.rolling_12_months_revenue} />
			  </View>
			</View>,

	};
  return <Document>
	<Page size="A4" style={styles.page}>
		<View style={styles.reportTitle}>
			<Text style={styles.roayltyWarning}>These reports are for analytical purposes only and should not be used to pay artist royalties</Text>
			<Text style={styles.header}>{reportTitle}</Text>
		</View>
		<View style={styles.section}>			
		</View>    
		{Object.values(allViews)}
	</Page>
  </Document>
};